<template>
  <label :for="uuid" v-if="label" class="block text-black mt-2">{{ label }}</label>
  <div class="relative">
    <select
      :id="uuid"
      :title="label"
      :value="modelValue"
      :aria-describedby="error ? `${systemName}-error` : ''"
      :aria-invalid="error ? true : false"
      v-bind="{
      ...$attrs,
      onChange: ($event) => { $emit('update:modelValue', ($event.target as HTMLInputElement).value) }}"
      class="block w-full px-4 py-3 pr-8 mt-1 bg-gray-100 appearance-none field focus:outline-none bg-grey-lighter text-grey-darker"
      :class="{ 'border rounded-sm border-red-800': error }"
      :disabled="disabled"
    >
      <option v-if="!defaultOption" value="">
        {{ defaultText }}
      </option>
      <option v-else selected :value="(defaultOption as any).value ?? defaultOption">
        {{ (defaultOption as any).name ?? defaultOption }}
      </option>
      <option
        v-for="option in options"
        :value="(option as NameValue).value ?? (option as string)"
        :key="(option as NameValue).value ?? (option as string)"
        :selected="option === modelValue"
      >
        <template v-if="typeof option === 'string'">{{ option }}</template>
        <template v-else>
          {{ (option as NameValue).name }}
        </template>
      </option>
    </select>
    <div
      class="absolute flex items-center px-2 pointer-events-none right-3 top-3 text-grey-darker"
    >
      <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path
          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        />
      </svg>
    </div>
  </div>
  <p
    :id="`${systemName}-error`"
    class="text-red-800"
    v-show="error"
    aria-live="assertive"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { NameValue } from "../sharedTypes";
import { ToSystemName } from "../helpers";
import { UniqueId } from "../helpers";

const uuid = UniqueId().getId();

const props = withDefaults(
  defineProps<{
    label?: string;
    modelValue?: string | number;
    error?: string;
    options?: NameValue[] | string[];
    defaultOption?: NameValue | string;
    defaultText?: string;
    disabled?: boolean;
  }>(),
  { defaultText: "--Please Select--" }
);

const systemName = ToSystemName(props.label ?? "");
</script>
